module.exports = __webpack_public_path__ + "img/ICON_app-click.93994a5f.png";